export default __webpack_public_path__ + "static/studyoffice-office1-9af4b37b5df4fdf38e02b6414b6fa701.jpg";